// src/features/payment/mapStatusToVariant.ts
// Maps payment domain status enums to Badge variants.

import type { PaymentAttemptStatus, PaymentStatus, PaymentProviderStatus } from '@core/types/payment';

export type BadgeVariant = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';

export function mapPaymentStatusToVariant(status: PaymentAttemptStatus): BadgeVariant {
  switch (status) {
    case 'PAYMENT_ATTEMPT_STATUS_PENDING':
      return 'warning';
    case 'PAYMENT_ATTEMPT_STATUS_SUCCESS':
      return 'success';
    case 'PAYMENT_ATTEMPT_STATUS_SOFT_DECLINE':
    case 'PAYMENT_ATTEMPT_STATUS_HARD_DECLINE':
    case 'PAYMENT_ATTEMPT_STATUS_ERROR':
      return 'error';
    case 'PAYMENT_ATTEMPT_STATUS_TIMEOUT':
      return 'warning';
    default:
      return 'secondary';
  }
}

export function mapPaymentEntryStatusToVariant(status: PaymentStatus | undefined): BadgeVariant {
  switch (status) {
    case 'PAYMENT_STATUS_CAPTURED':
    case 'PAYMENT_STATUS_SETTLED':
      return 'success';
    case 'PAYMENT_STATUS_PENDING':
    case 'PAYMENT_STATUS_AUTHORIZED':
      return 'warning';
    case 'PAYMENT_STATUS_FAILED':
    case 'PAYMENT_STATUS_DISPUTED':
    case 'PAYMENT_STATUS_CHARGEBACK':
      return 'error';
    case 'PAYMENT_STATUS_CANCELLED':
    case 'PAYMENT_STATUS_VOIDED':
      return 'secondary';
    case 'PAYMENT_STATUS_REFUNDED':
    case 'PAYMENT_STATUS_PARTIALLY_REFUNDED':
      return 'default';
    default:
      return 'secondary';
  }
}

export function mapProviderStatusToVariant(status: PaymentProviderStatus | undefined): BadgeVariant {
  switch (status) {
    case 'PAYMENT_PROVIDER_STATUS_ACTIVE':
      return 'success';
    case 'PAYMENT_PROVIDER_STATUS_DEGRADED':
      return 'warning';
    case 'PAYMENT_PROVIDER_STATUS_DISABLED':
      return 'error';
    default:
      return 'secondary';
  }
}
